import { useState } from 'react';

import {
  Avatar,
  Box,
  Button,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useModal } from 'react-modal-hook';

import MessageBase, { MessageBaseProps } from 'components/MessageBase';
import ModalAddContato from 'components/ModalAddContato';
import { ContatoInterface } from 'store/reducers/contatos';

import MessageErrorFallback from './MessageErrorFallback';

type ContatoMessageProps = MessageBaseProps;

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    overflow: 'hidden',
    minWidth: spacing(40),
  },
  avatar: {
    color: 'inherit',
    backgroundColor: palette.action.focus,
  },
}));

export default function ContatoMessage(props: ContatoMessageProps) {
  const classes = useStyles();

  const [mensagemContato, setMensagemContato] = useState<ContatoInterface>();

  const [showModalAddContato, hideModalAddContato] = useModal(
    ({ in: open }) => {
      if (!mensagemContato) return null;
      return (
        <ModalAddContato
          open={open}
          contato={mensagemContato}
          onClose={hideModalAddContato}
        />
      );
    },
    [mensagemContato],
  );

  const handleShowModalAddContato = (contato?: ContatoInterface) => {
    setMensagemContato(contato);
    showModalAddContato();
  };

  try {
    const { mensagem, fromMe } = props;
    const mensagemContato = mensagem?.mensagemContato as ContatoInterface;

    return (
      <MessageBase {...props}>
        <Box className={classes.root}>
          <ListItem component="div" divider={!fromMe} disableGutters dense>
            <ListItemAvatar>
              <Avatar className={classes.avatar} />
            </ListItemAvatar>

            <ListItemText
              primary={mensagemContato?.nome}
              secondary={mensagemContato?.contato}
              primaryTypographyProps={{ noWrap: true, color: 'inherit' }}
              secondaryTypographyProps={{
                noWrap: true,
                component: 'p',
                color: 'inherit',
                variant: 'caption',
                style: { opacity: 0.85 },
              }}
            />
          </ListItem>

          {!fromMe && (
            <ListItem component="div" disableGutters dense>
              <Button
                onClick={() => handleShowModalAddContato(mensagemContato)}
                size="small"
                fullWidth
              >
                Adicionar
              </Button>
            </ListItem>
          )}
        </Box>
      </MessageBase>
    );
  } catch (error) {
    return <MessageErrorFallback {...props} />;
  }
}
